import { render, staticRenderFns } from "./OnboardingConfirmationLink.vue?vue&type=template&id=6e10a9bf&scoped=true"
import script from "./OnboardingConfirmationLink.vue?vue&type=script&lang=js"
export * from "./OnboardingConfirmationLink.vue?vue&type=script&lang=js"
import style0 from "./OnboardingConfirmationLink.vue?vue&type=style&index=0&id=6e10a9bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10a9bf",
  null
  
)

export default component.exports